// Planlama (MRP) sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'production.planning';

export const productionPlanningGuide = (t: TFunction): GuideContent => ({
  layout: 'stacked',
  title: t(`${G}.title`, 'Planlama nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Planlama; siparişlere, elle girdiğiniz taleplere ve minimum stoklara bakıp ne kadar üretmeniz ve ne kadar satın almanız gerektiğini hesaplar. Hesap stoğa dokunmaz; yalnız siz fiş oluşturunca taslak üretim fişi açılır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Planlama'),
    form: t(`${G}.regions.form`, 'Parametreler ve elle talep'),
    list: t(`${G}.regions.list`, 'Sonuçlar'),
    footer: t(`${G}.regions.footer`, 'Fiş oluştur / Excel'),
  },
  steps: [
    {
      region: 'form',
      title: t(`${G}.s1.title`, '1. Parametreleri ayarlayın'),
      text: t(`${G}.s1.text`, '"Ufuk tarihi" zorunludur: bu tarihe kadar teslim edilecek açık siparişler hesaba girer. "Depolar" boşsa tüm depolar sayılır; birden çok şube varsa "Şube" seçebilirsiniz.'),
      tips: [
        t(`${G}.s1.tip1`, 'Açık satış siparişleri: ihtiyaç olarak sayılır. Açık alış siparişleri: beklenen giriş olarak sayılır.'),
        t(`${G}.s1.tip2`, 'Açık (serbest/üretimdeki) üretim fişlerinin mamulü beklenen giriş, girdileri ihtiyaçtır. "Taslak üretim fişleri" işaretliyse taslaklar da sayılır.'),
        t(`${G}.s1.tip3`, '"Minimum stok" işaretliyse ürün kartındaki minimum stok emniyet miktarı olarak eklenir. "Parti katına yuvarla" üretim önerisini reçetenin parti miktarının katına yukarı yuvarlar.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s2.title`, '2. Elle talep ekleyin (isteğe bağlı)'),
      text: t(`${G}.s2.text`, '"Elle talep" tablosuna "+ Satır" ile ürün, miktar, ihtiyaç tarihi ve not girin. "Excel\'den yapıştır" ile her satıra stok kodu veya barkod, sekme, miktar (isteğe bağlı tarih gg.aa.yyyy) yapıştırabilirsiniz; en fazla 500 satır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Ürün listesinde normalde reçetesi olan ürünler çıkar. Hammadde gibi başka bir ürün için talep girecekseniz "Tüm ürünler"i açın.'),
        t(`${G}.s2.tip2`, 'Bulunamayan ya da birden çok ürüne denk gelen satırlar "n satır çözülemedi" olarak gösterilir ve eklenmez.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s3.title`, '3. Hesaplayın'),
      text: t(`${G}.s3.text`, '"Hesapla"ya basın. Mamul ihtiyacı reçeteler üzerinden yarı mamullere ve hammaddelere de aktarılır (Seviye sütunu). Parametreleri değiştirirseniz "Parametreler değişti, yeniden hesaplayın" uyarısı çıkar.'),
      tips: [
        t(`${G}.s3.tip1`, 'Sonuç kaydedilmez; sayfa yenilenince silinir.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s4.title`, '4. Sonuçları okuyun'),
      text: t(`${G}.s4.text`, 'Kartlar üretim önerisi ve satın alma önerisi sayısını, tahmini satın alma tutarını ve uyarı sayısını gösterir. "Üretim", "Satın alma" ve "Tümü" sekmeleri arasında geçip arama ve sınıf ile süzebilirsiniz.'),
      tips: [
        t(`${G}.s4.tip1`, 'Net ihtiyaç = Brüt ihtiyaç + Emniyet − Eldeki − Beklenen giriş (sıfırın altına inmez). Öneri, net ihtiyacın yukarı yuvarlanmış hâlidir.'),
        t(`${G}.s4.tip2`, 'Brüt ihtiyaç rakamına tıklayınca ihtiyacın hangi kaynaktan geldiği (satış siparişi, elle plan, minimum stok, açık fiş girdisi, üst ürün üretimi) görünür.'),
        t(`${G}.s4.tip3`, '"Satışta açılır" etiketli ürün satışta reçeteden düşer; ihtiyacı malzemelerine aktarılır. Uyarı simgesinin üstüne gelince satırın uyarısı okunur.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s5.title`, '5. Öneriyi düzeltin ve seçin'),
      text: t(`${G}.s5.text`, '"Üretim" sekmesinde "Öneri" miktarını değiştirebilirsiniz. Üretim fişi açmak istediğiniz satırları soldaki kutularla seçin.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Fiş oluşturun ya da listeyi indirin'),
      text: t(`${G}.s6.text`, '"Seçilenler için üretim fişi oluştur (n)" depoları ve tarihi sorduğunuz pencereyi açar; fişler taslak olarak açılır. "Satın alma listesini indir" alış siparişi hazırlarken kullanacağınız listeyi, "Sonucu Excel\'e aktar" ekrandaki sonucu indirir. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
